// Regras das perguntas de um produto (adicionais, sabores, combos), usadas
// pela tela de produto do celular e pelo wizard do totem.

// Quantas opções o cliente já escolheu nesta pergunta.
export function answeredQttOf(question, answers) {
  return (answers || [])
    .filter((a) => a.questionId === question.id)
    .reduce((acc, a) => acc + a.qtt, 0);
}

// Pergunta obrigatória só está resolvida quando atinge o mínimo.
export function isQuestionSatisfied(question, answers) {
  return !(
    question.minQtt > 0 && answeredQttOf(question, answers) < question.minQtt
  );
}

export function unansweredRequiredQuestions(questions, answers) {
  return (questions || []).filter((q) => !isQuestionSatisfied(q, answers));
}

// Combo: todas as opções são itens inclusos, não há o que escolher.
export function isComboQuestion(question) {
  return question.options.reduce((acc, o) => acc && o.comboItem, true);
}

// Texto de apoio abaixo do título da pergunta. O totem usa a versão curta,
// lida de longe e sem o "opções".
export function questionHelpText(question, { short = false } = {}) {
  const { minQtt, maxQtt } = question;
  if (isComboQuestion(question)) {
    return short ? "" : "Itens inclusos";
  }
  if (short) {
    if (minQtt === maxQtt) return `Escolha ${minQtt}`;
    if (minQtt > 0) return `Escolha ${minQtt}, até ${maxQtt}`;
    return `Escolha até ${maxQtt}`;
  }
  if (minQtt === maxQtt) {
    return `Escolha ${minQtt} ${minQtt === 1 ? "opção" : "opções"}`;
  }
  if (minQtt > 0) return `Escolha de ${minQtt} a ${maxQtt} opções`;
  return `Escolha até ${maxQtt} ${maxQtt === 1 ? "opção" : "opções"}`;
}
